import React from 'react';
import Modal from '../../../../components/modal/Modal';

export const DeleteAttribute = ({ deleteProps, handleOnSubmit, deleteFormRef, deleteBtnLoader, setToggleDelete }) => {
  return (
    <Modal {...deleteProps} className="sidebar__modal--center" title="">
      <form name="delete" ref={deleteFormRef} className="ant-form ant-form-horizontal" onSubmit={(event) => handleOnSubmit({ event: event, form: deleteProps })}>
        <h2 className="text-center mb-4">Are you sure you want to delete the selected item ?</h2>

        <div className="form-group form-group-modal mb-4">
          {!deleteBtnLoader ? (
            <button data-cy="modal-delete-submit-btn" type="submit" className="btn btn-primary-link">
              <span className="text">Yes</span>
            </button>
          ) : (
            <button type="button" className="btn btn-primary-outline">
              <span className="text">Deleting...</span>
            </button>
          )}

          <button data-cy="modal-delete-cancel-btn" type="button" className="btn btn-primary" onClick={() => setToggleDelete(false)}>
            <span className="text">No</span>
          </button>
        </div>
      </form>
    </Modal>
  );
};
